<div 
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" 
  (click)="onDismiss()"
>
  <div 
    class="bg-white rounded-2xl p-6 max-w-md mx-4 shadow-xl" 
    (click)="$event.stopPropagation()"
  >
    @if (isDenied()) {
      <h3 class="text-2xl font-bold text-gray-900 mb-4">Notifications blocked</h3>
      <p class="text-gray-600 mb-4">You previously blocked notifications. To enable them:</p>
      <ol class="text-gray-600 mb-6 list-decimal list-inside space-y-2">
        <li>Click the lock/info icon in the address bar</li>
        <li>Find "Notifications" setting</li>
        <li>Change to "Allow"</li>
        <li>Refresh the page</li>
      </ol>
      
      <div class="flex justify-end">
        <button
          type="button"
          (click)="onDismiss()"
          class="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
        >
          Got it
        </button>
      </div>
    } @else {
      <h3 class="text-2xl font-bold text-gray-900 mb-4">Enable notifications?</h3>
      <p class="text-gray-600 mb-6">Get updates when your order status changes.</p>
      
      <div class="flex gap-3 justify-end">
        <button
          type="button"
          (click)="onDismiss()"
          class="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
        >
          Not now
        </button>
        <button
          type="button"
          (click)="onEnable()"
          class="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
        >
          Enable
        </button>
      </div>
    }
  </div>
</div>
